import { render, staticRenderFns } from "./InventorySidepanel.vue?vue&type=template&id=4fac5e6e&scoped=true&"
import script from "./InventorySidepanel.vue?vue&type=script&lang=js&"
export * from "./InventorySidepanel.vue?vue&type=script&lang=js&"
import style0 from "./InventorySidepanel.vue?vue&type=style&index=0&id=4fac5e6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac5e6e",
  null
  
)

export default component.exports